import {FC} from 'react';

import {FilterDialogItemType} from 'filters/features/FilterDialog/types';

import {RadioGroupItem} from 'filters/features/FilterDialog/sections/ItemsSection/items/RadioGroupItem';

export const dialogItemsMap = {
  [FilterDialogItemType.RadioGroup]: RadioGroupItem,
} satisfies Record<string, FC<any>>;
